
const BASKET_KEY = "basket";
const BASKET_EXPIRY_KEY = "basketExpiry";
const EXPIRY_TIME = 1000 * 60 * 60; // 1 hour (change this as needed)

// 🧠 Helper — check expiry
function isExpired() {
  const expiry = parseInt(localStorage.getItem(BASKET_EXPIRY_KEY), 10);
  return expiry && Date.now() > expiry;
}

// 🧺 Add item to basket
export function addToBasket(item, itemPriceId, itemPrice, quantity = 1) {
  const basket = getBasket(); // This will already clear expired baskets

  // Check if the item already exists
  const existingItem = basket.find((i) => i.priceId === itemPriceId);

  if (existingItem) {
    existingItem.quantity += quantity;
  } else {
    basket.push({
      name: item.title,
      priceId: itemPriceId,
      quantity,
      thumbnail: item.mockup || null,
      price: itemPrice,
      id: item.id,
      size: item.getSize() || ''
    });
  }

  // Save back to localStorage
  localStorage.setItem(BASKET_KEY, JSON.stringify(basket));

  // Reset expiry timer (extends life when user adds something)
  localStorage.setItem(BASKET_EXPIRY_KEY, Date.now() + EXPIRY_TIME);

  // console.log("Item added/updated in basket:", itemPriceId);
  // console.log("Current basket:", basket);

  // Notify components
  window.dispatchEvent(new Event("basketUpdated"));
}

// 🧾 Get basket items
export function getBasket() {
  if (isExpired()) {
    clearBasket();
    return [];
  }

  return JSON.parse(localStorage.getItem(BASKET_KEY) || "[]");
}

// 🧹 Clear basket
export function clearBasket() {
  localStorage.removeItem(BASKET_KEY);
  localStorage.removeItem(BASKET_EXPIRY_KEY);

  window.dispatchEvent(new Event("basketUpdated"));
}

// 🔢 Get total quantity
export function getBasketQuantity() {
  const basket = getBasket();
  return basket.reduce((total, item) => total + item.quantity, 0);
}